import { configureStore } from "@reduxjs/toolkit";
import bothiesReducer from "./bothiesSlice";
import weatherReducer from "./weatherSlice";

export const store = configureStore({
  reducer: {
    bothies: bothiesReducer,
    weather: weatherReducer
  }
});

export default store;
